













































































































import { Organization } from "@/models/Organization";
import restService from "@/services/restService";
import { IMovitInstance } from "@/typings/timit";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import vuetifyToast from "vuetify-toast";
import Destination from "../Passenger/models/Destination";

interface ICreateDestination {
  alias: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  movitInstanceId: number;
  organizationId: string;
  priceArea: number;
}

@Component({
  components: {},
})
export default class CreateDestinationModal extends Vue {
  destinationIsValid: boolean = false;

  newDestination: ICreateDestination = {
    alias: "",
    streetAddress: "",
    postalCode: "",
    city: "",
    movitInstanceId: 0,
    organizationId: "",
    priceArea: 0,
  };

  priceAreas = [0, 1, 2, 3, 4, 5, 6];

  rules: any = {
    required: (val) =>
      !!val || this.$i18n.translate("validation.rules.required", "Required"),
    validPostalCode: (val) =>
      this.validatePostalCode(val) ||
      this.$i18n.translate(
        "validation.rules.postalCode",
        "Postal code must 5 characters long and can not include letters or special characters."
      ),
  };

  instances: IMovitInstance[] = [];

  @Prop({ default: false }) open: boolean;
  @Prop({ default: null }) organizationId: string | null;

  @Watch("organizationId", { immediate: true })
  async setOrganizationId() {
    this.newDestination.organizationId = this.organizationId;
    this.getServiceProviders(this.newDestination.organizationId);
  }

  get isEspoo() {
    if (!this.organizationId) {
      return false;
    }

    const espooOrganizations: string[] = [
      '626a6858-8c19-4a69-b699-12e577ce012a'.toLowerCase(),
      '17dd2fb9-4253-4503-881d-f5cdb305ceaf'.toLowerCase()
    ];
    
    return espooOrganizations.includes(this.organizationId.toLowerCase());
  }

  get checkAddress() {
    return (this.$store.state.organization.organizations as Organization[])
    .find(o => o.id === this.organizationId)
    .destinations.some(d => d.address.toLowerCase() === this.newDestination.streetAddress.toLowerCase());
  }

  get matchingDestination() {
    if (this.checkAddress) {
      return (this.$store.state.organization.organizations as Organization[])
      .find(o => o.id === this.organizationId)
      .destinations.find(d => d.address.toLowerCase() === this.newDestination.streetAddress.toLowerCase()).alias;
    }
    return '';
  }

  validatePostalCode(val: any) {
    const regex = new RegExp("^\\d{5}$");
    return regex.test(val);
  }

  async getServiceProviders(organizationId: string) {
    this.instances = await restService.organizations.getServiceProviders(
      organizationId
    );
  }

  async createDestination() {
    try {
      const result = await this.$store.dispatch(
        "organization/createDestinationForOrganization",
        { data: this.newDestination }
      );

      const organization: Organization = this.$store.state.organization.organizations
        .find(o => o.id === this.newDestination.organizationId);

      const newDestination = organization.destinations.find(d => d.id === result.data.id);

      this.$store.commit("destination/addDestination", newDestination);
      this.$store.commit("user/addDestinationPermission", newDestination);

      vuetifyToast.success(
        this.$i18n.translate(
          "organization.addDestination.sent",
          "Destination added."
        )
      );
      this.closeEditor();
    } catch (error) {
      vuetifyToast.error(
        this.$i18n.translate(
          "organization.addDestination.error",
          "Adding destination failed: {errorMessage}",
          {
            errorMessage: error,
          }
        )
      );
    }
  }

  closeEditor() {
    this.emptyForm();
    this.$emit("close");
  }

  emptyForm() {
    this.newDestination.alias = "";
    this.newDestination.streetAddress = "";
    this.newDestination.city = "";
    this.newDestination.postalCode = "";
    this.newDestination.movitInstanceId = 0;

    (this.$refs.form as any).resetValidation();
  }
}
